module.exports = __webpack_public_path__ + "static/img/slsServer1.4ebbda4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slsServer1.png
// module id = Jv8N
// module chunks = 2